var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('v-icon',{attrs:{"color":"teal"},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v("mdi-send")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }